var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("plain-text-control", {
        attrs: {
          title:
            "BudgetaryEstimate.Investment.SupportApartments.Apartment.Title",
          required: true
        }
      }),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: {
            "aria-label": _vm.$t(
              "BudgetaryEstimate.Investment.SupportApartments.Apartment.Title"
            )
          }
        },
        [
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                {
                  staticClass: "w-20",
                  attrs: { id: "SupportApartments_targetGroup" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.TargetGroup"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-20",
                  attrs: { id: "SupportApartments_municipality" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.Municipality"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-10 right",
                  attrs: { id: "SupportApartments_count" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.Count"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-10 right",
                  attrs: { id: "SupportApartments_size" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.AvgSize"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-10 right",
                  attrs: { id: "SupportApartments_price" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.AvgPrice"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-10 right",
                  attrs: { id: "SupportApartments_repairs" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.AvgRepairCosts"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-15 right",
                  attrs: { id: "SupportApartments_totalCosts" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "BudgetaryEstimate.Investment.SupportApartments.Apartment.TotalCosts"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-5 centered",
                  attrs: { id: "SupportApartments_actions" }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("Sr_Actions")))
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "tr",
                { key: index },
                [
                  _vm.targetGroupOptions
                    ? _c("single-select-table-cell", {
                        attrs: {
                          classes: ["input-cell"],
                          value: item.targetGroup ? item.targetGroup : null,
                          options: _vm.targetGroupOptions,
                          required: true,
                          doNotUseResources: true,
                          srLabel: true,
                          title:
                            "BudgetaryEstimate.Investment.SupportApartments.Apartment.TargetGroup",
                          dropdownId: "targetgroups_" + (index + 1)
                        },
                        on: {
                          input: function($event) {
                            return _vm.mapTargetGroupToModel(item, $event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.municipalities
                    ? _c("single-select-table-cell", {
                        attrs: {
                          classes: ["input-cell"],
                          options: _vm.municipalities,
                          required: true,
                          doNotUseResources: true,
                          srLabel: true,
                          title:
                            "BudgetaryEstimate.Investment.SupportApartments.Apartment.Municipality",
                          dropdownId: "apartmentmunicipalities_" + index,
                          optionOutput: true
                        },
                        model: {
                          value: item.municipality,
                          callback: function($$v) {
                            _vm.$set(item, "municipality", $$v)
                          },
                          expression: "item.municipality"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "w-10 input-cell" },
                    [
                      _c("numeric-input-control", {
                        attrs: {
                          required: true,
                          labelledBy: "SupportApartments_count"
                        },
                        nativeOn: {
                          change: function($event) {
                            return _vm.calculateTotalForItem(item)
                          }
                        },
                        model: {
                          value: item.count,
                          callback: function($$v) {
                            _vm.$set(item, "count", $$v)
                          },
                          expression: "item.count"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "w-10 input-cell" },
                    [
                      _c("numeric-input-control", {
                        attrs: {
                          required: true,
                          labelledBy: "SupportApartments_size"
                        },
                        nativeOn: {
                          change: function($event) {
                            return _vm.calculateTotalForItem(item)
                          }
                        },
                        model: {
                          value: item.avgSize,
                          callback: function($$v) {
                            _vm.$set(item, "avgSize", $$v)
                          },
                          expression: "item.avgSize"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "w-10 input-cell" },
                    [
                      _c("numeric-input-control", {
                        attrs: {
                          required: true,
                          labelledBy: "SupportApartments_price"
                        },
                        nativeOn: {
                          change: function($event) {
                            return _vm.calculateTotalForItem(item)
                          }
                        },
                        model: {
                          value: item.avgPrice,
                          callback: function($$v) {
                            _vm.$set(item, "avgPrice", $$v)
                          },
                          expression: "item.avgPrice"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "w-10 input-cell" },
                    [
                      _c("numeric-input-control", {
                        attrs: {
                          required: true,
                          labelledBy: "SupportApartments_repairs"
                        },
                        nativeOn: {
                          change: function($event) {
                            return _vm.calculateTotalForItem(item)
                          }
                        },
                        model: {
                          value: item.avgRepairCosts,
                          callback: function($$v) {
                            _vm.$set(item, "avgRepairCosts", $$v)
                          },
                          expression: "item.avgRepairCosts"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "w-15 disabled-background right" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("formatNumber")(item.totalCosts)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "w-5 centered" }, [
                    _c("span", [
                      _vm.showDeleteBtn && !_vm.isReadOnly
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: { content: _vm.$t("Btn_DeleteRow") },
                                  expression:
                                    "{ content: $t('Btn_DeleteRow') }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass: "btn btn-link btn-contrast",
                              attrs: {
                                type: "button",
                                "aria-label":
                                  _vm.$t("Btn_DeleteRow") +
                                  (index + 2) +
                                  " -. " +
                                  _vm.$t("Accessibility.ConfirmDeleteRow")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRow(index)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-trash-alt fa-lg centered"
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  staticClass: "w-85 disabled-background",
                  attrs: { colspan: "6" }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Total"))))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("td", { staticClass: "w-10 right disabled-background" }, [
                _c("span", [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "BudgetaryEstimate.Investment.SupportApartments.Apartment.TotalCosts"
                          ) + _vm.$t("Total")
                        ) +
                        " "
                    )
                  ]),
                  _vm._v(_vm._s(_vm._f("formatNumber")(_vm.total)))
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "w-5 disabled-background" })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("div", { staticClass: "mt-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: {
                  type: "button",
                  disabled: _vm.isAddNewRowDisabled,
                  "aria-disabled": _vm.isAddNewRowDisabled
                },
                on: {
                  click: function($event) {
                    return _vm.addRow()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Btn_AddRow")))]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }